export const CheckerTypes = {
    duplicateOrganisationCkeck: {
        checks: {
            bulstat: "NUMBER",
            vat: "VAT_NUMBER"
        }
    }
}